import React, { useState } from "react";
import { FloatButton, Modal, List } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const ActionFAB = () => {
    const [open, setOpen] = useState(false);

    const actions = [
        "Vendre un produit",
        "Acheter",
        "Publier une offre",
        "Postuler à un job",
    ];

    return (
        <>
            <FloatButton
                icon={<PlusOutlined />}
                type="primary"
                style={{ right: 24, bottom: 24 }}
                onClick={() => setOpen(true)}
            />

            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                title="Nouvelle activité"
            >
                <List
                    dataSource={actions}
                    renderItem={(item) => <List.Item>{item}</List.Item>}
                />
            </Modal>
        </>
    );
};

export default ActionFAB;